import { InjectionToken } from '@angular/core';

export const CURRENT_ORG_ID: InjectionToken<number> = new InjectionToken<number>('currentOrgId', {
  providedIn: 'root',
  factory: () => parseInt((window.location.pathname.match(/\/organization:(\d+)/) || [])[1], 10) || undefined,
});
